import React, { useEffect, useState } from "react";
import VendorAddEditForm from "./VendorForm";
import { axios } from "../../../../Global";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ListDataVendor from "./ListDataVendor";
import PromptElement from "../../PromptElement";
import { printValidationError } from "../../../../utils/functions";
import { checkAccessFn } from "../../../../utils/checkAccess";
import Breadcrumb from "../../../../utils/BreadCrumb";

export default function RecruitmentAgency(props) {
  const location = useLocation();
  const isCreateMode = location.pathname.endsWith("/recruitment-agency/create");
  const isEditMode = location.pathname.includes("/recruitment-agency/edit");
  const [listLoading,setListLoading] = useState(false)
  const commonItems = [{ label: 'RECRUITMENT AGENCY', link: '/dashboard/recruitment-agency' }];
  const breadcrumbItems = isEditMode
    ? [...commonItems, { label: 'EDIT', link: '' }]
    : isCreateMode
    ? [...commonItems, { label: 'CREATE', link: '' }]
    : commonItems;

  const [showPromptElement, setShowPromptElement] = useState({
    open: false,
    id: null,
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [submitFormLoading, setSubmitFormLoading] = useState(false);
  const [nationalities, setNationalities] = useState([]);
  const [loading, setLoading] = useState({
    edit: false,
    delete: false,
    listData: false,
    loadingId: "",
  });
  const [vendorList, setVendorList] = useState([]);
  const [addOrEdit, setAddOrEdit] = useState({
    open: false,
    method: "",
    loadedValues: {},
    editId: "",
  });

  useEffect(() => {
    if (location.pathname.split("/")[3] === "create") {
      setAddOrEdit((p) => ({ ...p, open: true }));
    } else {
      setAddOrEdit((p) => ({ ...p, open: false }));
    }
  }, [location]);

  const [name, setName] = useState("");
  const [shortName, setShortName] = useState("");
  const [authorizedName, setAuthorizedName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [address, setAddress] = useState("");
  const [country, setCountry] = useState("");
  const [prevState, setPrevState] = useState({
    name: "",
    shortName: "",
    authorizedName: "",
    email: "",
    mobile: "",
    address: "",
    country: "",
  });

  const token = localStorage.getItem("token");
  const getRecruitmentAgencies = () => {
   setListLoading(true)
    try {
      axios
        .get("/dashboard/vendor", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setVendorList(res.data.data.vendor);
          setNationalities(res.data?.data?.nationality);
          setListLoading(false);
        })
        .catch((err) => {
          setListLoading(false);
          dispatch(
            setAppError({
              msg: err.message,
            })
          );
        });
    } catch (error) {
      dispatch(setAppError({ msg: "Something went wrong" }));
    }
  };
  useEffect(() => {
    getRecruitmentAgencies();
  }, []);

  const submitForm = async (event) => {
    event.preventDefault();
    setSubmitFormLoading(true);
    try {
      let response;
      const body = {
        name,
        short_name: shortName,
        authorized_person_name: authorizedName,
        address,
        email,
        mobile,
        nationality_id: country,
      };
      if (addOrEdit.method === "add") {
        response = await axios.post(`/dashboard/vendor`, body, {
          headers: { Authorization: `Bearer ${token}` },
        });
      } else if (addOrEdit.method === "edit") {
        if (
          name === prevState.name &&
          shortName === prevState?.shortName &&
          authorizedName === prevState.authorizedName &&
          email === prevState.email &&
          mobile === prevState.mobile &&
          address === prevState.address &&
          country === prevState.country
        ) {
          setSubmitFormLoading(false);
          return dispatch(setAppError({ msg: "No changes made" }));
        }
        response = await axios.put(
          `/dashboard/vendor/${addOrEdit.editId}`,
          body,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      }
      const data = response?.data?.data;
      console.log(data, "data");
      getRecruitmentAgencies();
      if (data) {
        navigate("/dashboard/recruitment-agency");
        dispatch(
          setAppError({
            msg: response.data.message,
            color: "success",
          })
        );
        setSubmitFormLoading(false);
        setAddOrEdit((p) => ({ ...p, open: false }));
      }
    } catch (err) {
      printValidationError(err, "vendor");
      setSubmitFormLoading(false);
      dispatch(
        setAppError({
          msg: err?.message,
        })
      );
    }
  };

  const cancelForm = () => {
    navigate("/dashboard/recruitment-agency");
    setAddOrEdit((p) => ({ ...p, open: false }));
  };
  const editData = async (id, data) => {
    navigate(`/dashboard/recruitment-agency/edit/${id}`);
    setPrevState({
      name: data.name,
      short_name: data.short_name,
      authorizedName: data.authorized_person_name,
      email: data.email,
      mobile: data.mobile,
      address: data.address,
      country: data.nationality_id,
    });
    if (id) {
      setLoading((p) => ({ ...p, edit: true, loadingId: id }));
      try {
        await new Promise((resolve) => setTimeout(resolve, 300));
        setLoading((p) => ({ ...p, edit: false, loadingId: "" }));
        setAddOrEdit((p) => ({
          ...p,
          open: true,
          method: "edit",
          editId: id,
        }));
        setName(data.name);
        setShortName(data?.short_name);
        setEmail(data.email);
        setMobile(data.mobile);
        setAddress(data.address);
        setAuthorizedName(data.authorized_person_name);
        setCountry(data.nationality_id);
      } catch (err) {
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      }
    }
  };
  const deleteData = async (id) => {
    if (id) {
      setLoading((p) => ({ ...p, delete: true, loadingId: id }));
      try {
        const response = await axios.delete(`/dashboard/vendor/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        getRecruitmentAgencies();
        if (response?.status === 200) {
          setLoading((p) => ({ ...p, delete: false, loadingId: "" }));
          dispatch(
            setAppError({
              msg: response.data.message,
              color: "bg-green-700",
            })
          );
        }
      } catch (err) {
        if (err?.response?.status === 403) {
          if (err?.response?.data?.message) {
            dispatch(setAppError({ msg: err?.response?.data.message }));
          }
        } else {
          dispatch(setAppError({ msg: err.message }));
        }
        setLoading((p) => ({ ...p, delete: false }));
      }
    }
  };

  const addData = () => {
    setAddOrEdit((p) => ({ ...p, open: true, method: "add" }));
    setName("");
    setShortName("");
    setAuthorizedName("");
    setAddress("");
    setEmail("");
    setMobile("");
    setCountry("");
  };

  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) =>
    checkAccessFn(dashboardData, module, name);

    useEffect(() => {
      dispatch(setBreadCrumb(breadcrumbItems))
    }, [location.pathname]);

  return (
    <>
      {showPromptElement.open && (
        <PromptElement
          showPromptElement={showPromptElement}
          setShowPromptElement={setShowPromptElement}
          deleteHandler={deleteData}
        />
      )}
      <div className={`p-2  sm:p-5 `}>
        {!addOrEdit.open && (
          <>
            <ListDataVendor
              list={vendorList}
              editData={editData}
              deleteData={setShowPromptElement}
              loading={loading}
              column={5}
              listLoading={listLoading}
              titles={[
                "S.NO.",
                "REC. AGENCY ID",
                "REC. AGENCY NAME",
                "REC. AGENCY SHORT NAME",
                "AGENCY EMAIL",
                "NATIONALITY",
                "NATIONAL ADDRESS",
                "AUTHORIZED NAME",
                "ACTION",
              ]}
              addData={addData}
            />
          </>
        )}
        {addOrEdit.open && (
          <VendorAddEditForm
            component="vendor"
            form={[
              {
                type: "text",
                text: "REC. Agency Name",
                name: "name",
                value: name,
                update: setName,
                columnName: "name",
              },
              {
                type: "text",
                text: "REC. Agency Short Name",
                name: "short_name",
                value: shortName,
                update: setShortName,
                columnName: "short_name",
              },
              {
                type: "email",
                text: "REC. Agency Email",
                name: "email",
                value: email,
                update: setEmail,
                columnName: "email",
              },
              {
                type: "text",
                text: "Authorized Name",
                name: "authorizedName",
                value: authorizedName,
                update: setAuthorizedName,
                columnName: "authorizedName",
              },
              {
                type: "textarea",
                text: "National Address",
                name: "address",
                value: address,
                update: setAddress,
                columnName: "address",
              },
              {
                type: "number",
                text: "Company Landline Number",
                name: "mobile",
                value: mobile,
                update: setMobile,
                pattern: "[0-9]*",
                columnName: "mobile",
              },
              {
                type: "select",
                text: "Country",
                name: "country",
                value: country,
                update: setCountry,
                columnName: "country",
                options: nationalities,
              },
            ]}
            submitForm={submitForm}
            cancelForm={cancelForm}
            submitFormLoading={submitFormLoading}
            loadedValues={
              addOrEdit.method === "edit" && addOrEdit.loadedValues
                ? true
                : false
            }
          />
        )}
      </div>
    </>
  );
}
